import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CtaProps, ImageCard } from '../../../atoms';
import { useDnaCategoryResults, useMe } from '../../../config/api/queries';
import { CHECKOUT_URLS } from '../../../config/index';

export const DNAResultsCard = ({
  scrollToOrderTracking,
}: {
  scrollToOrderTracking?: () => void;
}): JSX.Element => {
  const me = useMe();
  const dnaCategories = useDnaCategoryResults();
  const navigate = useNavigate();

  const dnaStates: { [name: string]: CtaProps } = {
    results_available: {
      btnId: 'dna-report',
      text: 'View full report',
      subText: "We've adjusted your formula based on your results",
      func: () => navigate('/dashboard/dna-report'),
    },
    // TODO - can bring back if new blood tests are added
    // ordered: {
    //   btnId: 'dna-track-order',
    //   text: 'Track Order',
    //   subText: 'We got your order!',
    //   func: () =>
    //     scrollToOrderTracking
    //       ? scrollToOrderTracking()
    //       : navigate('/dashboard'),
    // },
    // needs_order: {
    //   btnId: 'dna-report-order',
    //   subText: 'Results within 3-4 weeks',
    //   text: 'Order DNA test',
    //   link: CHECKOUT_URLS.dna_test.link,
    // },
  };

  const [dnaState, setDnaState] = useState<CtaProps>();

  useEffect(() => {
    if (dnaCategories.data?.length) {
      setDnaState(dnaStates.results_available);
      return;
    }
    if (me.data) {
      if (me.data.dna_status === 'ordered') {
        setDnaState(dnaStates.ordered);
      } else if (me.data.dna_status !== '') {
        setDnaState(undefined);
      } else {
        setDnaState(dnaStates.needs_order);
      }
    }
  }, [dnaCategories.data, me.data]);

  return (
    <ImageCard
      image="/images/dna_result_card.jpg"
      alttext="image of dna strand"
      variant="halfImage"
      title="DNA Report"
      description="Uncover what your data is telling you. Learn why your genes make you unique - start optimizing your health today."
      cta={dnaState}
    />
  );
};
